import api from "./axios";

export const getMySubscription = () => api.get("/api/subscriptions/plans/me/");

export const getPlans = () => api.get("/api/subscriptions/plans/");

// createSubscription moved to /api/payments/checkout/subscription/ —
// import { checkoutSubscription } from "./payments.api" instead.
